import { MarketConfig } from '@/shared/market'

import { TermsSection } from './types'

export const getTermsData = (market: MarketConfig): TermsSection[] => [
  {
    id: 1,
    title: 'Acceptance of Terms',
    content: [
      'By accessing and using PixieWorld\'s website and services, you accept and agree to be bound by the terms and provision of this agreement.',
      'If you do not agree to abide by the above, please do not use this service.',
    ],
  },
  {
    id: 2,
    title: 'Use License',
    content: [
      'Permission is granted to temporarily download one copy of the materials (information or software) on PixieWorld\'s website for personal, non-commercial transitory viewing only.',
      'This is the grant of a license, not a transfer of title, and under this license you may not:',
      '• Modify or copy the materials',
      '• Use the materials for any commercial purpose or for any public display',
      '• Attempt to reverse engineer any software contained on PixieWorld\'s website',
      '• Remove any copyright or other proprietary notations from the materials',
      '• Transfer the materials to another person or "mirror" the materials on any other server',
    ],
  },
  {
    id: 3,
    title: 'Personalized Books',
    content: [
      'PixieWorld creates personalized storybooks based on the information and preferences you provide.',
      'You are responsible for ensuring that all information provided (names, images, personal details) is accurate and appropriate.',
      'PixieWorld reserves the right to refuse service for content that is deemed inappropriate, offensive, or in violation of applicable laws.',
      'Once a personalized book is created and ordered, changes may not be possible. Please review your book carefully before placing your order.',
    ],
  },
  {
    id: 4,
    title: 'Intellectual Property',
    content: [
      'All content, designs, illustrations, and text created by PixieWorld remain the intellectual property of PixieWorld.',
      'The personalized book you purchase grants you a personal, non-commercial license to use and enjoy the book.',
      'You may not reproduce, distribute, or create derivative works from PixieWorld\'s proprietary content without express written permission.',
      'Any images or content you upload must be owned by you or used with proper authorization.',
    ],
  },
  {
    id: 5,
    title: 'Pricing and Payment',
    content: [
      'All prices are listed in the currency specified on the website and are subject to change without notice.',
      'Payment must be received in full before we process and ship your order.',
      'We accept major credit cards and other payment methods as displayed at checkout.',
      'Promotional codes and discounts cannot be combined unless explicitly stated.',
    ],
  },
  {
    id: 6,
    title: 'Shipping and Delivery',
    content: [
      'Shipping times are estimates and are not guaranteed.',
      'PixieWorld is not responsible for delays caused by shipping carriers or customs.',
      'You are responsible for providing accurate shipping information. PixieWorld is not liable for packages delivered to incorrect addresses due to customer error.',
      'Risk of loss and title for items purchased pass to you upon delivery to the shipping carrier.',
    ],
  },
  {
    id: 7,
    title: 'Returns and Refunds',
    content: [
      'Digital Products: We offer a 30-day money-back guarantee on all digital product purchases. If you are not satisfied for any reason, you may request a full refund within 30 days of your purchase date.',
      'Personalized Physical Books: Due to the personalized nature of our printed books, we cannot accept returns for change of mind. If your book arrives damaged or defective, please contact us within 7 days of delivery with photos of the damage. We will assess each case individually and may offer a replacement or refund at our discretion.',
      'Refunds, if approved, will be processed within 5–10 business days to the original payment method.',
      'For full details, please see our Refund Policy page.',
    ],
  },
  {
    id: 8,
    title: 'Privacy',
    content: [
      'Your use of PixieWorld\'s website is also governed by our Privacy Policy.',
      'We collect and use personal information as described in our Privacy Policy to provide and improve our services.',
      'We take reasonable measures to protect your personal information but cannot guarantee absolute security.',
    ],
  },
  {
    id: 9,
    title: 'Disclaimer',
    content: [
      'The materials on PixieWorld\'s website are provided on an "as is" basis.',
      'PixieWorld makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.',
      'PixieWorld does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.',
    ],
  },
  {
    id: 10,
    title: 'Limitations',
    content: [
      'In no event shall PixieWorld or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on PixieWorld\'s website.',
      'This limitation applies even if PixieWorld or a PixieWorld authorized representative has been notified orally or in writing of the possibility of such damage.',
    ],
  },
  {
    id: 11,
    title: 'Revisions and Errata',
    content: [
      'The materials appearing on PixieWorld\'s website could include technical, typographical, or photographic errors.',
      'PixieWorld does not warrant that any of the materials on its website are accurate, complete, or current.',
      'PixieWorld may make changes to the materials contained on its website at any time without notice.',
      'PixieWorld does not make any commitment to update the materials.',
    ],
  },
  {
    id: 12,
    title: 'Governing Law',
    content: [
      `These terms and conditions are governed by and construed in accordance with the laws of ${market.companyInfo.jurisdiction}.`,
      'You irrevocably submit to the exclusive jurisdiction of the courts in that location.',
    ],
  },
  {
    id: 13,
    title: 'Changes to Terms',
    content: [
      'PixieWorld reserves the right to modify these terms at any time.',
      'By continuing to use the website after changes are posted, you agree to be bound by the revised terms.',
      'It is your responsibility to review these terms periodically for changes.',
    ],
  },
  {
    id: 14,
    title: 'Contact Information',
    content: [
      'If you have any questions about these Terms and Conditions, please contact us at:',
      'Email: support@pixie.education',
    ],
  },
]
